import React, {useEffect, useState} from 'react';
import './TopPage.scss';
import TitleImg from '../../images/top__title.png';
import SpTitleImg from '../../images/sp/top__title.png';
import ArrowImg from '../../images/top__arrow.png';
import SpArrowImg from '../../images/sp/top__arrow.png';
import CopyImg from '../../images/top__copy.png';
import SpCopyImg from '../../images/sp/top__copy.png';
import StartButtonImg from '../../images/top__start-button.png';
import StartButtonHoverImg from '../../images/top__start-button--hover.png';
import VideoFrameImg from '../../images/top__video-frame.png';
import SpVideoFrameImg from '../../images/sp/top__video-frame.png';
import {EveryonesSmile} from "./../EveryonesSmile";
import {Store} from "../../models/Store";
import {OverlayVideo} from "../OverlayVideo";

export const TopPage = (props: {
    onDone: () => void;
}) => {

    const [isOpened, setIsOpened] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);

        (async () => {
            const a = await Store.firestore_group_isOpened(Store.groupId);
            setIsOpened(a);
        })();
    }, []);

    return (<div className='top'>

        <div className='top__title-wrapper'>

            <div className='top__title'><h1><img src={Store.isDeviceMobile ? SpTitleImg : TitleImg} width={434}
                                                 height={330}
                                                 alt=""/></h1></div>

            <div className='top__arrow-wrapper'><img className='top__arrow'
                                                     src={Store.isDeviceMobile ? SpArrowImg : ArrowImg} width={47}
                                                     height={50}
                                                     alt=""/></div>

        </div>

        <div className='top__copy-wrapper'><img src={Store.isDeviceMobile ? SpCopyImg : CopyImg} className='top__copy'
                                                alt="" width={1197} height={80}/>
        </div>

        <div className='top__video-container'>

            {/*<iframe src="https://www.youtube.com/embed/FL5VH0mwcRE?rel=0&amp;showinfo=0" frameBorder="0" allowFullScreen*/}
            {/*        title="." width={932} height={526}/>*/}

            <iframe width={Store.isDeviceMobile ? 238 : 932} height={Store.isDeviceMobile ? 134 : 526}
                    src="https://www.youtube.com/embed/10xiz1LMVd0?rel=0&autoplay=0&fs=0"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen title={'video2'}></iframe>

            <img src={Store.isDeviceMobile ? SpVideoFrameImg : VideoFrameImg} alt="" width={936} height={530}/>
        </div>

        <div className='top__about-wrapper'>＞<a className='top__about'
                                                href="https://hikarino-mi.jp" target='_blank'
                                                rel="noopener noreferrer">ひかりの実とは？</a></div>

        {isOpened && <StartButton onDone={props.onDone}/>}

        {(!Store.isWorkshop && isOpened) && <div className='top__once'>Please draw once with your best smile!<br/>
            ※ みんなも描くので 一人一回にしてね。</div>}

        <div className='top__recommend-env'>
            <div className='top__recommend-env__left'>Recommended Browsers / 推奨ブラウザ</div>
            <div className='top__recommend-env__split'><img src="img/top__env-split.png" alt=""/></div>
            <div className='top__recommend-env__right'>
                <ul>
                    <li>Windows Chrome (Latest/最新版)</li>
                    <li>Mac Safari (Latest/最新版), Chrome (Latest/最新版)</li>
                    <li>iOS 12~ Safari</li>
                    <li>Android 9~ Chrome</li>
                </ul>
            </div>
        </div>

        <EveryonesSmile mobile={true}/>

        <OverlayVideo/>

        {!isOpened && <div className='top__closed-text'>スマイルアトリエに来ていただきありがとうございます。<br/>
            たくさんの方にご参加いただき、本企画の募集数が集まりました。<br/>
            募集を終了とさせていただきます。<br/>
            みんなの笑顔がどんな風に光るのか、楽しみにしていてください。</div>}
    </div>);
};

const StartButton = (props: { onDone: () => void; }) => {

    if (!Store.firestore_group_isOpened) {
        return (<div></div>)
    }

    if (Store.isWorkshop) {
        return (<div className='top__start-text-wrapper'><img src={'./img/ws/top__wait-for-start.png'} alt=''/></div>);
    } else {
        return (<div className='top__start-button-wrapper'><img onClick={props.onDone} width={218} height={100}
                                                                src={StartButtonImg}
                                                                onMouseOver={e => e.currentTarget.src = StartButtonHoverImg}
                                                                onMouseOut={e => e.currentTarget.src = StartButtonImg}
                                                                style={{cursor: 'pointer'}} alt=""/></div>);
    }
};